import { render, staticRenderFns } from "./ChatOverlay.vue?vue&type=template&id=4d6c8b62&"
import script from "./ChatOverlay.vue?vue&type=script&lang=js&"
export * from "./ChatOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ChatOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports